import {useState, useEffect} from 'react';
import { Grid, CardContent, Typography, Tooltip } from '@mui/material';

import PercentComplete from './PercentCompleteComponent';
import ProfitPercentage from './CurrentProfitComponent';

import CurrentContractAmount from './CurrentContractAmountComponent';
import OGContractAmount from './OriginalContractAmountComponent';
import TotalEstimatedCosts from './TotalEstimatedCostsComponent';
import JTDCosts from './JTDCostsComponent';
import ContractChangePercentage from './ContractChangePercentageComponent';
import ProfitChangePercentage from './ProfitChangePercentageComponent';
import RevisedBudget from './RevisedBudgetComponent';
import ApprovedChangeEvents from './ApprovedChangeEventsComponent';
import ChangeEventRevenue from './ChangeEventRevenueComponent';


const MasterContractInfoCard = ({ budgetData }) => {

	// useEffect to trigger re-render when delayed budgetData is received
		// API currently lagging projectData endpoint by ~20sec
	const [updatedBudgetData, setUpdatedBudgetData] = useState(null);

	useEffect(() => {
		if (budgetData) {
			setUpdatedBudgetData(budgetData);
		}
	}, [budgetData]);

	return (
		<CardContent sx={{marginBottom: '-30px', marginTop: '-15px', marginLeft: '-20px', marginRight: '-20px'}}>
				<Grid container spacing={{ xs: 2 }} sx={{ width: '100%', justifyContent: 'center' }}>
			{/* Original Contact  */}
				<Grid size={{ xs: 4 }}>
					<Typography variant="subtitle1" className="card-title" sx={{ textAlign: 'center' }}>Original Contract</Typography>
					<OGContractAmount budgetData={budgetData} />
				</Grid>
			{/* Current Contract */}
				<Grid size={{ xs: 4 }}>
						<Typography variant="subtitle1" className="card-title" sx={{ textAlign: 'center' }}>Current Contract</Typography>
						<span className='ppsf-container'>
							<Tooltip
								title={
									<div className="warning-icon-tooltip-content">
										<Typography sx={{fontSize: '1rem', padding: '5px', borderRadius: '3px', fontFamily: 'Titillium Web, sans-serif'}}>Sum of Original Contract and Approved Changes (Approved PCOs and PCCOs).</Typography>
									</div>
								}
							>
								<span>
								<CurrentContractAmount budgetData={budgetData} />
								</span>
							</Tooltip>
						</span>
					</Grid>
				{/* Revised Budget */}
				<Grid size={{ xs: 4 }}>
					<Typography variant="subtitle1" className="card-title" sx={{ textAlign: 'center' }}>Projected Contract</Typography>
					<Tooltip
						title={
							<div className="warning-icon-tooltip-content">
								<Typography sx={{fontSize: '1rem', padding: '5px', borderRadius: '3px', fontFamily: 'Titillium Web, sans-serif'}}>Sum of Current Contract and Potential Changes (open PCOs and Change Event Revenue). The "Revised Budget" in Procore.</Typography>
							</div>
						}
						>
					<span>
						<RevisedBudget budgetData={budgetData} />
					</span>
					</Tooltip>
					<Tooltip
								title={
									<div className="warning-icon-tooltip-content">
										<Typography sx={{fontSize: '1rem', padding: '5px', borderRadius: '3px', fontFamily: 'Titillium Web, sans-serif'}}>Change in Projected Contract Amount compared to the last snapshot.</Typography>
									</div>
								}
								>
								<span>
									<ContractChangePercentage budgetData={budgetData} />
								</span>
							</Tooltip>

				</Grid>
				
				{/* Approved PCOS & PCCOS */}
				<Grid size={{ xs: 4 }}>
					<Typography variant="subtitle1" className="card-title" sx={{ textAlign: 'center' }}>Approved Changes</Typography>
					<Tooltip
						title={
							<div className="warning-icon-tooltip-content">
								<Typography sx={{fontSize: '1rem', padding: '5px', borderRadius: '3px', fontFamily: 'Titillium Web, sans-serif'}}>Sum of all approved PCOs and PCCOs.</Typography>
							</div>
						}
						>
					<span>
						<ApprovedChangeEvents budgetData={budgetData} />
					</span>
					</Tooltip>
				</Grid>
				{/* Change Event Revenue */}
				<Grid size={{ xs: 4 }}>
					<Typography variant="subtitle1" className="card-title" sx={{ textAlign: 'center' }}>Potential Changes</Typography>
					<Tooltip
						title={
							<div className="warning-icon-tooltip-content">
								<Typography sx={{fontSize: '1rem', padding: '5px', borderRadius: '3px', fontFamily: 'Titillium Web, sans-serif'}}>Sum of Open PCOs and Change Event Revenue.</Typography>
							</div>
						}
						>
					<span>
						<ChangeEventRevenue budgetData={budgetData} />
					</span>
					</Tooltip>
				</Grid>
				{/* Current Profit $ [%] */}
				<Grid size={{ xs: 4 }}>
					<Typography variant="subtitle1" className="card-title" sx={{ textAlign: 'center' }}>Current Profit $ [%]</Typography>
					<span className='ppsf-container'>
						<ProfitPercentage budgetData={budgetData} />
						<Tooltip
							title={
								<div className="warning-icon-tooltip-content">
									<Typography sx={{fontSize: '1rem', padding: '5px', borderRadius: '3px', fontFamily: 'Titillium Web, sans-serif'}}>Change in profit over the past month.</Typography>
								</div>
							}
						>
						<span>
							<ProfitChangePercentage budgetData={budgetData} />
						</span>
						</Tooltip>
					</span>
				</Grid>
			   
				{/* JTD Costs */}
				<Grid size={{ xs: 4 }}>
					<Typography variant="subtitle1" className="card-title" sx={{ textAlign: 'center' }}>JTD Costs</Typography>
					<JTDCosts budgetData={budgetData} />
				</Grid>

			   {/* Estimated Costs */}
				<Grid size={{ xs: 4 }}>
					<Typography variant="subtitle1" className="card-title" sx={{ textAlign: 'center' }}>Estimated Costs</Typography>
					<TotalEstimatedCosts budgetData={budgetData} />
				</Grid>

				 {/* Percent Complete */}
				 <Grid size={{ xs: 4 }}>
					<Typography variant="subtitle1" className="card-title" sx={{ textAlign: 'center' }}>Percent Complete</Typography>
					<Tooltip
							title={
								<div className="warning-icon-tooltip-content">
									<Typography sx={{fontSize: '1rem', padding: '5px', borderRadius: '3px', fontFamily: 'Titillium Web, sans-serif'}}>Calculated as JTD Costs/Estimated Costs.</Typography>
								</div>
							}
						>
						<span>
							<PercentComplete budgetData={budgetData} />
						</span>
					</Tooltip>
				</Grid>
		 </Grid>
		</CardContent>
	)
}


export default MasterContractInfoCard;